import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  assignedTo: {
    description: 'shipmentsGrid.columns.assignedTo',
    defaultMessage: 'Assigned To',
    id: '77Udgn',
  },
  batch: {
    description: 'shipmentsGrid.columns.batch',
    defaultMessage: 'Batch',
    id: 'wYFhuy',
  },
  carrierFee: {
    description: 'shipmentsGrid.columns.carrierFee',
    defaultMessage: 'Carrier Fee',
    id: 'q0Z4GM',
  },
  carrier: {
    description: 'shipmentsGrid.columns.carrier',
    defaultMessage: 'Carrier',
    id: 'o4meXI',
  },
  city: {
    description: 'shipmentsGrid.columns.city',
    defaultMessage: 'City',
    id: 'CdsRSp',
  },
  company: {
    description: 'shipmentsGrid.columns.company',
    defaultMessage: 'Company',
    id: 'iNjfUY',
  },
  confirmation: {
    description: 'shipmentsGrid.columns.confirmation',
    defaultMessage: 'Confirmation',
    id: 'IUY4P0',
  },
  country: {
    description: 'shipmentsGrid.columns.country',
    defaultMessage: 'Country',
    id: 'UM28lk',
  },
  createdDate: {
    description: 'shipmentsGrid.columns.createdDate',
    defaultMessage: 'Created Date',
    id: 'E1rZdN',
  },
  customsForms: {
    description: 'shipmentsGrid.columns.customsForms',
    defaultMessage: 'Customs Forms',
    id: 'SzmE7O',
  },
  forms: {
    description: 'shipmentsGrid.columns.Forms',
    defaultMessage: 'Forms',
    id: 'OST0RP',
  },
  deliveryNotification: {
    description: 'shipmentsGrid.columns.deliveryNotification',
    defaultMessage: 'Delivery Notification',
    id: 'dk76Pj',
  },
  sent: {
    description: 'shipmentsGrid.columns.sent',
    defaultMessage: 'Sent',
    id: 'kMdVFk',
  },
  endOfDayForm: {
    description: 'shipmentsGrid.columns.endOfDayForm',
    defaultMessage: 'End Of Day Form',
    id: '0/plwJ',
  },
  insuranceFee: {
    description: 'shipmentsGrid.columns.insuranceFee',
    defaultMessage: 'Insurance Fee',
    id: 'z4lKSB',
  },
  duties: {
    description: 'shipmentsGrid.columns.duties',
    defaultMessage: 'Duties',
    id: 'ulSDEL',
  },
  tax: {
    description: 'shipmentsGrid.columns.tax',
    defaultMessage: 'Tax',
    id: 'l+WwE6',
  },
  importFees: {
    description: 'shipmentsGrid.columns.importFees',
    defaultMessage: 'Import Fees',
    id: 'Q5lIKU',
  },
  insurance: {
    description: 'shipmentsGrid.columns.insurance',
    defaultMessage: 'Insurance',
    id: 'dwWGvN',
  },
  labelCreated: {
    description: 'shipmentsGrid.columns.labelCreated',
    defaultMessage: 'Label Created',
    id: 'FBsJdb',
  },
  created: {
    description: 'shipmentsGrid.columns.created',
    defaultMessage: 'Created',
    id: 'JL7dpJ',
  },
  labelPrinted: {
    description: 'shipmentsGrid.columns.labelPrinted',
    defaultMessage: 'Label Printed',
    id: 'T4CBE5',
  },
  printed: {
    description: 'shipmentsGrid.columns.labelPrinted.printed',
    defaultMessage: 'Printed',
    id: 'Y5UY+L',
  },
  marketplaceNotified: {
    description: 'shipmentsGrid.columns.marketplaceNotified',
    defaultMessage: 'Marketplace Notified',
    id: 'FPzrcs',
  },
  marketplaceNotifiedTooltipTitle: {
    description: 'title for interactive popover',
    defaultMessage: 'Marketplace Notification Error',
    id: '/5EJ4y',
  },
  notified: {
    description: 'shipmentsGrid.columns.marketplaceNotified.notified',
    defaultMessage: 'Notified',
    id: '4qGZJ9',
  },
  orderDate: {
    description: 'shipmentsGrid.columns.orderDate',
    defaultMessage: 'Order Date',
    id: 'EFZUww',
  },
  orderNumber: {
    description: 'shipmentsGrid.columns.orderNumber',
    defaultMessage: 'Order #',
    id: 'K1BK2K',
  },
  packageText: {
    description: 'shipmentsGrid.columns.package',
    defaultMessage: 'Package',
    id: 'Hi9eMW',
  },
  packingSlipPrinted: {
    description: 'shipmentsGrid.columns.packingSlipPrinted',
    defaultMessage: 'Packing Slip Printed',
    id: 'GnOIrN',
  },
  paidDate: {
    description: 'shipmentsGrid.columns.paidDate',
    defaultMessage: 'Paid Date',
    id: 'Qr4XDQ',
  },
  postalCode: {
    description: 'shipmentsGrid.columns.postalCode',
    defaultMessage: 'Postal Code',
    id: 'tHOFS1',
  },
  provider: {
    description: 'shipmentsGrid.columns.provider',
    defaultMessage: 'Provider',
    id: '4g9H2+',
  },
  quantity: {
    description: 'shipmentsGrid.columns.quantity',
    defaultMessage: 'Quantity',
    id: '2PABlx',
  },
  rate: {
    description: 'shipmentsGrid.columns.rate',
    defaultMessage: 'Rate',
    id: 'kOpCUe',
  },
  recipient: {
    description: 'shipmentsGrid.columns.recipient',
    defaultMessage: 'Recipient',
    id: 'cCCi4g',
  },
  service: {
    description: 'shipmentsGrid.columns.service',
    defaultMessage: 'Service',
    id: '5DF6NK',
  },
  shipDate: {
    description: 'shipmentsGrid.columns.shipDate',
    defaultMessage: 'Ship Date',
    id: 'WPSMT5',
  },
  shipFrom: {
    description: 'shipmentsGrid.columns.shipFrom',
    defaultMessage: 'Ship From',
    id: 'yLlhwr',
  },
  shipmentNotification: {
    description: 'shipmentsGrid.columns.shipmentNotification',
    defaultMessage: 'Shipment Notification',
    id: 'JtPs4I',
  },
  shipmentNotificationTooltipTitle: {
    description: 'shipment notification tooltip error message title',
    defaultMessage: 'Shipment Notification Error',
    id: 'dzOA0l',
  },
  shipmentNumber: {
    description: 'shipmentsGrid.columns.shipmentNumber',
    defaultMessage: 'Shipment #',
    id: 'pmQQ5R',
  },
  shippingAccount: {
    description: 'shipmentsGrid.columns.shippingAccount',
    defaultMessage: 'Shipping Account',
    id: 'ERvwf0',
  },
  shippingPaid: {
    description: 'shipmentsGrid.columns.shippingPaid',
    defaultMessage: 'Shipping Paid',
    id: '+pbZ7b',
  },
  source: {
    description: 'shipmentsGrid.columns.source',
    defaultMessage: 'Source',
    id: '+SFQdU',
  },
  state: {
    description: 'shipmentsGrid.columns.state',
    defaultMessage: 'State',
    id: '9KiFvE',
  },
  store: {
    description: 'shipmentsGrid.columns.store',
    defaultMessage: 'Store',
    id: 'SxVTnS',
  },
  taxPaid: {
    description: 'shipmentsGrid.columns.taxPaid',
    defaultMessage: 'Tax Paid',
    id: 'BoKFLY',
  },
  trackingNumber: {
    description: 'shipmentsGrid.columns.trackingNumber',
    defaultMessage: 'Tracking #',
    id: 'YavElF',
  },
  weight: {
    description: 'shipmentsGrid.columns.weight',
    defaultMessage: 'Weight',
    id: 'v+sb8e',
  },
  verified: {
    description: 'shipments grid shipment verified message',
    defaultMessage: 'Verified',
    id: 'Z/4AdT',
  },
  verifiedBy: {
    description: 'shipments grid shipment verified  by message',
    defaultMessage: 'Verified by {userName}',
    id: 'sjm0yL',
  },
  scanToVerifyStatus: {
    description: 'shipments grid scan to verify status column',
    defaultMessage: 'Scan To Verify',
    id: '9W1FxE',
  },
  notificationSent: {
    description: 'Marketplace notified column for the Sent status',
    defaultMessage: 'Notification sent but not confirmed',
    id: 'XS3fw/',
  },
  rateShopper: {
    description: 'Display text for the Rate Shopper column',
    defaultMessage: 'Rate Shopper',
    id: 'BeuRmT',
  },
  shipmentRefundAssistNavItemLabel: {
    description: 'label for the Refund Assist Grid that will be displayed in the left nav under the Shipment tab',
    defaultMessage: 'Refund Assist',
    id: 'x8Kf01',
  },
  shipmentRefundAssistPageTitle: {
    description: 'Title displayed on the Refund Assist Grid page',
    defaultMessage: 'Shipped / Refund Assist',
    id: 'Ac/wmV',
  },
  refundAssistDisabledPlaceholderTitle: {
    description: 'Title displayed on the Refund Assist Grid page when Refund Assist is disabled',
    defaultMessage: "Refund Assist isn't enabled",
    id: 'oOmKAp',
  },
  refundAssistDisabledPlaceholderDescription: {
    description: 'Description text below the title on the Refund Assist Grid page when Refund Assist is disabled',
    defaultMessage: 'Refund Assist helps you recover costs from unused USPS labels.',
    id: 'ZdBB7n',
  },
  refundAssistDisabledPlaceholderButtonText: {
    description: 'Button text on the Refund Assist Grid page when Refund Assist is disabled',
    defaultMessage: 'Enable Refund Assist',
    id: '9iW6Ac',
  },
  refundAmountRequested: {
    description: 'column in the refund assist grid that displays the amount requested from the carrier',
    defaultMessage: 'Refund Amount Requested',
    id: 'K3RtUh',
  },
  refundCompletedUtc: {
    description: 'column in the refund assist grid that displays the date the refund was completed',
    defaultMessage: 'Refund Completed',
    id: 'nyWVRz',
  },
  refundRequestedStartUtc: {
    description: 'column in the refund assist grid that displays the date the refund request was sent to the carrier',
    defaultMessage: 'Refund Request Date',
    id: 'd87WdK',
  },
  refundedAmount: {
    description: 'column in the refund assist grid that displays the acual amount refunded from the carrier',
    defaultMessage: 'Credited Amount',
    id: 'mXEWPZ',
  },
  refundStatus: {
    description: 'column in the refund assist grid that displays the refund status',
    defaultMessage: 'Refund Status',
    id: 'tO+rHs',
  },
  refundStatusEligible: {
    description: 'refund status type eligible',
    defaultMessage: 'Eligible',
    id: 'FAy7g3',
  },
  refundStatusRequestScheduled: {
    description: 'refund status type request scheduled',
    defaultMessage: 'Request Scheduled',
    id: 'gA9b7t',
  },
  refundStatusPending: {
    description: 'refund status type pending',
    defaultMessage: 'Pending',
    id: 'HAC5Bm',
  },
  refundStatusApproved: {
    description: 'refund status type approved',
    defaultMessage: 'Approved',
    id: 'LnbqI2',
  },
  refundStatusCancelled: {
    description: 'refund status type cancelled',
    defaultMessage: 'Cancelled',
    id: 'Q1KvqQ',
  },
  refundStatusExcluded: {
    description: 'text displayed in the Refund Assist Grid when the refund status type is cancelled',
    defaultMessage: 'Excluded',
    id: 'gGg9aT',
  },
  refundStatusRejected: {
    description: 'refund status type rejected',
    defaultMessage: 'Rejected',
    id: 'AimbZh',
  },
  refundStatusDisabled: {
    description: 'refund status type disabled',
    defaultMessage: 'Disabled',
    id: 'xItxAZ',
  },
  voidType: {
    description: 'column header for the Void Type column being added to the Voided grid',
    defaultMessage: 'Void Type',
    id: '+7esxO',
  },
  voidTypeManual: {
    description: 'The void type for any shipments that are manually voided',
    defaultMessage: 'Manual',
    id: 'jxLZBD',
  },
  voidTypeRefundAssist: {
    description: 'The void type for any shipments that were voided automatically via Refund Assist',
    defaultMessage: 'Refund Assist',
    id: 'K+XZHK',
  },
});
